/**
 * Правовая оговорка ТЗ 4.2.5 — ЕДИНСТВЕННЫЙ носитель этого текста в приложении.
 *
 * ТЗ: «во всех расчётных формах выводится оговорка: расчёты являются справочными; вопросы снижения
 * неустойки (ст. 333 ГК РФ), действия мораторных периодов и особенностей течения давности
 * оцениваются юристом».
 *
 * Формулировка НОРМАТИВНАЯ — менять нельзя (это предмет приёмки). Текст закреплён тестом на точное
 * совпадение, чтобы его не «улучшили» при рефакторинге.
 *
 * Компонент рендерится ВНУТРИ каждой расчётной формы (карточка расчёта, блок исковой давности,
 * форма претензии), а не на месте вызова — так забыть его физически нельзя.
 */

export const LEGAL_DISCLAIMER =
  "расчёты являются справочными; вопросы снижения неустойки (ст. 333 ГК РФ), действия мораторных периодов и особенностей течения давности оцениваются юристом";

export function LegalDisclaimer() {
  return (
    <p className="mt-3 border-t border-border-soft pt-2 text-[12px] leading-snug text-muted">
      <span className="font-bold">Оговорка:</span> {LEGAL_DISCLAIMER}.
    </p>
  );
}
